import PropTypes from 'prop-types';
import React from 'react';

export default function campCell(props) {

  return (
    <td>
      <a target="_blank" 
         href={`/#/Publicite/Calendrier-Gant/Projets/${props.dataItem.camp_seq}`} 
         className="blueLink" rel='noreferrer'
      >{props.dataItem.camp_descr}</a>
    </td>
  );
}

campCell.propTypes = {
  dataItem: PropTypes.any,
  field: PropTypes.any,
};
